define('home/templates/completeReportUser',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"modal-header\">\n<h4 class=\"modal-title\">"
    + alias2(helpers.gettext.call(alias1,"Report sent",{"name":"gettext","hash":{},"data":data}))
    + "</h4>\n</div>\n<div class=\"modal-body\">\n<p>"
    + alias2(helpers.gettext.call(alias1,"Thank you for reporting this user. This helps moderators remove inappropriate comments and profiles. Disqus will take action against their account if they have violated our policies.",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n</div>\n";
},"useData":true})

});
